import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClientCard } from '../components/client-card.js';
import { ClientSearchField } from '../fields/client-search-field.js';
import { withFieldGroup } from '../hooks/use-app-form.js';
import { ContactSection } from './contact-section';
export const ClientSection = withFieldGroup({
    defaultValues: {},
    props: {},
    render: function Render({ children, editablePhone = false, group, mode, onClientSelected, selectedClient, }) {
        // Champ Téléphone éditable, injecté dans les modes lecture seule quand le compte n'a pas de numéro.
        const editablePhoneField = editablePhone ? (_jsx(group.AppField, { name: "contactPhoneNumber", children: (field) => _jsx(field.PhoneNumberField, { label: "T\u00E9l\u00E9phone" }) })) : null;
        // Edit mode: show read-only client card
        if (mode === 'edit') {
            return (_jsxs(ContactSection, { fields: {
                    clientFirstName: 'clientFirstName',
                    clientLastName: 'clientLastName',
                    contactEmail: 'contactEmail',
                    contactPhoneNumber: 'contactPhoneNumber',
                }, form: group, title: "Client", hideFields: true, headerContent: _jsx(group.Subscribe, { selector: (state) => ({
                        email: state.values.contactEmail,
                        firstName: state.values.clientFirstName,
                        lastName: state.values.clientLastName,
                        phoneNumber: state.values.contactPhoneNumber,
                    }), children: (clientInfo) => (_jsx(ClientCard, { client: {
                            email: clientInfo.email,
                            firstName: clientInfo.firstName,
                            lastName: clientInfo.lastName,
                            phoneNumbers: clientInfo.phoneNumber
                                ? [{ number: clientInfo.phoneNumber, type: 'PRINCIPAL' }]
                                : [],
                        }, mode: "readonly" })) }), children: [editablePhoneField, children] }));
        }
        // Create mode with client search
        if (onClientSelected) {
            return (_jsxs(ContactSection, { fields: {
                    clientFirstName: 'clientFirstName',
                    clientLastName: 'clientLastName',
                    contactEmail: 'contactEmail',
                    contactPhoneNumber: 'contactPhoneNumber',
                }, form: group, title: "Client", hideFields: !!selectedClient, headerContent: _jsx(ClientSearchField, { onClientSelected: (client) => {
                        onClientSelected(client);
                        const opts = { dontValidate: true };
                        if (client) {
                            group.setFieldValue('contactEmail', client.email ?? '', opts);
                            group.setFieldValue('clientFirstName', client.firstName ?? '', opts);
                            group.setFieldValue('clientLastName', client.lastName ?? '', opts);
                            group.setFieldValue('contactPhoneNumber', client.phoneNumbers?.find((p) => p.type === 'PRINCIPAL')?.number ??
                                client.phoneNumbers?.[0]?.number ??
                                '', opts);
                        }
                        else {
                            group.setFieldValue('contactEmail', '', opts);
                            group.setFieldValue('clientFirstName', '', opts);
                            group.setFieldValue('clientLastName', '', opts);
                            group.setFieldValue('contactPhoneNumber', '', opts);
                        }
                        group.setFieldMeta('contactEmail', (prev) => ({ ...prev, errors: [] }));
                        group.setFieldMeta('clientFirstName', (prev) => ({ ...prev, errors: [] }));
                        group.setFieldMeta('clientLastName', (prev) => ({ ...prev, errors: [] }));
                        group.setFieldMeta('contactPhoneNumber', (prev) => ({ ...prev, errors: [] }));
                    }, selectedClient: selectedClient ?? null }), children: [selectedClient ? editablePhoneField : null, children] }));
        }
        // Fallback: simple contact fields
        return (_jsx(ContactSection, { fields: {
                clientFirstName: 'clientFirstName',
                clientLastName: 'clientLastName',
                contactEmail: 'contactEmail',
                contactPhoneNumber: 'contactPhoneNumber',
            }, form: group, title: "Client", children: children }));
    },
});
